var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app","data-ver":_vm.version,"mg-stat-page":"score_newHome","mg-stat-autopv":"false"}},[(_vm.isInit)?_c('router-view'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }